const doc = [({"en":({"js":({"nemoa":({"users":({"passwords":({"new":({"forgot_your_password":"Forgot your adgangskode?"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;